import { createApp } from 'vue'
import router from './router'
import store from './store'
import "animate.css"
import WOW from 'wow.js'

const wow = new WOW({
    boxClass: 'wow',
    animateClass: 'animated',
    offset: 0,
    mobile: false,
    live: true
})

wow.init()

const app = createApp(App)

// 引入重置样式
import "./assets/css/reset.css"

// 引入 iconfont 图标
import './assets/fonts/iconfont.css'

// import './less/index.less'
import './icons/index'
import 'vue-waterfall-plugin-next/dist/style.css'

// 引入公共组件
import { registerComponents } from './components'
registerComponents(app);

// UI框架
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'

// 全局注册图标
import * as Icons from '@element-plus/icons-vue'
for (let iconName in Icons) {
    app.component(iconName, Icons[iconName])
}

// 引入插件和语言包
import I18n from './language'
import SvgIcon from "@/components/SvgIcon/SvgIcon.vue";

/* 数据交互
    安装、配置代理、封装 */
app.component('SvgIcon', SvgIcon)

app.use(I18n).use(ElementPlus).use(store).use(router).mount('#app')